import { Box, Grid, IconButton, Popover } from "@mui/material";
import {
  linear_item,
  linear_h,
  linear_v,
} from "../../../libs/linear-layout/LinearLayout";
import RhfSelect from "../../../libs/rhf-mui/RhfSelect";
import _, { set } from "lodash";
import RhfErrorText from "../../../libs/rhf-mui/RhfErrorText";
import { UniQuestion } from "../../dao/UniQuestion";
import { Info, InfoOutlined } from "@mui/icons-material";
import { useState } from "react";
import { useTranslation } from "react-i18next";

type Props = {
  question: UniQuestion;
};

const UcHumanBodyImage = ({ question }: Props) => {
  const { t } = useTranslation();
  let sx_cbo: any = { width: "100%" };
  let options = [
    { value: "", label: "" },
    { value: "1", label: t("1(微痛)") },
    { value: "2", label: t("2(中等疼痛)") },
    { value: "3", label: t("3(劇痛)") },
    { value: "4", label: t("4(非常疼痛)") },
    { value: "5", label: t("5(極度劇痛)") },
  ];

  function render_Select(rhf_name: string, isRightSide: boolean = false) {
    const text = rhf_name.replace("m03.", "").replace(/_/g, "/");
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          gap: "8px",
          flex: 1,
          alignItems: "center",
        }}
      >
        {!isRightSide && (
          <RhfSelect
            name={rhf_name}
            options={options}
            label={""}
            size="small"
            sx={{ width: "64px" }}
          />
        )}

        <Box
          sx={{
            fontSize: {
              xs: "0.6rem",
              sm: "0.8rem",
              md: "1rem",
            },
            width: "calc(100% - 64px)",
            textAlign: isRightSide ? "end" : "start",
            wordBreak: "break-word",
            overflowWrap: "break-word",
          }}
        >
          {t(text)}
        </Box>

        {isRightSide && (
          <RhfSelect
            name={rhf_name}
            options={options}
            label={""}
            size="small"
            sx={{ width: "64px" }}
          />
        )}
      </Box>
    );
  }

  function render_humanbody_image(question: UniQuestion) {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          mx: "auto",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            width: "100%",
            justifyContent: "center",
          }}
        >
          <RhfErrorText name={"m03.人體圖"} />
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            width: "100%",
            justifyContent: "center",
          }}
        >
          <Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                height: "100%",
              }}
            >
              {render_Select(RHF_NAME_頸)}
              {render_Select(RHF_NAME_左肩)}
              {render_Select(RHF_NAME_左手肘_左前臂)}
              {render_Select(RHF_NAME_左手_左手腕)}
              {render_Select(RHF_NAME_左臀_左大腿)}
              {render_Select(RHF_NAME_左膝)}
              {render_Select(RHF_NAME_左腳踝_左腳)}
            </Box>
          </Box>
          <Box>
            <img
              style={{ height: "100%" }}
              src="/assets/images/肌肉骨骼人體圖-左側(等分).png"
              alt="肌肉骨骼人體圖-左側"
            />
          </Box>
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: "row-reverse",
            width: "100%",
            justifyContent: "center",
          }}
        >
          <Box sx={{ width: "calc(100%-145px)" }}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                height: "100%",
              }}
            >
              {render_Select(RHF_NAME_上背, true)}
              {render_Select(RHF_NAME_右肩, true)}
              {render_Select(RHF_NAME_右手肘_右前臂, true)}
              {render_Select(RHF_NAME_下背, true)}
              {render_Select(RHF_NAME_右手_右手腕, true)}
              {render_Select(RHF_NAME_右臀_右大腿, true)}
              {render_Select(RHF_NAME_右膝, true)}
              {render_Select(RHF_NAME_右腳踝_右腳, true)}
            </Box>
          </Box>
          <Box sx={{ width: "145px" }}>
            <img
              style={{ height: "100%" }}
              src="/assets/images/肌肉骨骼人體圖-右側(等分).png"
              alt="肌肉骨骼人體圖-左側"
            />
          </Box>
        </Box>
      </Box>
    );
  }

  return <div>{render_humanbody_image(question)}</div>;
};
/* 左半邊7個欄位 */
export const RHF_NAME_頸 = "m03.頸";
export const RHF_NAME_左肩 = "m03.左肩";
export const RHF_NAME_左手肘_左前臂 = "m03.左手肘_左前臂";
export const RHF_NAME_左手_左手腕 = "m03.左手_左手腕";
export const RHF_NAME_左臀_左大腿 = "m03.左臀_左大腿";
export const RHF_NAME_左膝 = "m03.左膝";
export const RHF_NAME_左腳踝_左腳 = "m03.左腳踝_左腳";

/* 右半邊8個欄位 */
export const RHF_NAME_上背 = "m03.上背";
export const RHF_NAME_右肩 = "m03.右肩";
export const RHF_NAME_右手肘_右前臂 = "m03.右手肘_右前臂";
export const RHF_NAME_下背 = "m03.下背";
export const RHF_NAME_右手_右手腕 = "m03.右手_右手腕";
export const RHF_NAME_右臀_右大腿 = "m03.右臀_右大腿";
export const RHF_NAME_右膝 = "m03.右膝";
export const RHF_NAME_右腳踝_右腳 = "m03.右腳踝_右腳";

export const UcHumanBodyImage_RHF_NAME_List = [
  RHF_NAME_頸,
  RHF_NAME_左肩,
  RHF_NAME_左手肘_左前臂,
  RHF_NAME_左手_左手腕,
  RHF_NAME_左臀_左大腿,
  RHF_NAME_左膝,
  RHF_NAME_左腳踝_左腳,

  RHF_NAME_上背,
  RHF_NAME_右肩,
  RHF_NAME_右手肘_右前臂,
  RHF_NAME_下背,
  RHF_NAME_右手_右手腕,
  RHF_NAME_右臀_右大腿,
  RHF_NAME_右膝,
  RHF_NAME_右腳踝_右腳,
];

/** 清空人體圖答案 */
export function UcHumanBodyImage_ClearValues(rhf_data: any) {
  for (const rhf_name of UcHumanBodyImage_RHF_NAME_List) {
    _.set(rhf_data, rhf_name, undefined);
  }
}

export default UcHumanBodyImage;
